module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "anxiety.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:11:53 2018",
		"id": 8856515
	},
	"speakers": [
		{
			"duration": "1.13",
			"confidence": null,
			"name": "F1",
			"time": "3.43"
		},
		{
			"duration": "177.77",
			"confidence": null,
			"name": "F2",
			"time": "7.09"
		}
	],
	"words": [
		{
			"duration": "0.21",
			"confidence": "0.470",
			"name": "Wow",
			"time": "3.43"
		},
		{
			"duration": "0.54",
			"confidence": "0.670",
			"name": ".",
			"time": "4.02"
		},
		{
			"duration": "0.18",
			"confidence": "0.900",
			"name": "So",
			"time": "7.09"
		},
		{
			"duration": "0.09",
			"confidence": "0.960",
			"name": "I",
			"time": "8.64"
		},
		{
			"duration": "0.25",
			"confidence": "0.900",
			"name": "really",
			"time": "8.73"
		},
		{
			"duration": "0.27",
			"confidence": "0.500",
			"name": "release",
			"time": "9.30"
		},
		{
			"duration": "0.19",
			"confidence": "0.470",
			"name": "them",
			"time": "9.74"
		},
		{
			"duration": "0.18",
			"confidence": "0.520",
			"name": "my",
			"time": "10.00"
		},
		{
			"duration": "0.31",
			"confidence": "0.990",
			"name": "last",
			"time": "10.22"
		},
		{
			"duration": "0.41",
			"confidence": "0.950",
			"name": "video",
			"time": "10.53"
		},
		{
			"duration": "0.04",
			"confidence": "0.640",
			"name": ".",
			"time": "13.34"
		},
		{
			"duration": "0.61",
			"confidence": "0.880",
			"name": "Pluto",
			"time": "13.76"
		},
		{
			"duration": "0.34",
			"confidence": "0.910",
			"name": "that's",
			"time": "14.39"
		},
		{
			"duration": "0.18",
			"confidence": "0.960",
			"name": "no",
			"time": "14.74"
		},
		{
			"duration": "0.41",
			"confidence": "0.960",
			"name": "different",
			"time": "15.43"
		},
		{
			"duration": "1.11",
			"confidence": "0.740",
			"name": ".",
			"time": "15.85"
		},
		{
			"duration": "0.11",
			"confidence": "0.570",
			"name": "And",
			"time": "16.98"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "17.20"
		},
		{
			"duration": "0.17",
			"confidence": "0.640",
			"name": "can",
			"time": "17.32"
		},
		{
			"duration": "0.46",
			"confidence": "1.000",
			"name": "probably",
			"time": "17.49"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "hear",
			"time": "17.95"
		},
		{
			"duration": "0.15",
			"confidence": "0.680",
			"name": "that",
			"time": "19.94"
		},
		{
			"duration": "0.15",
			"confidence": "0.330",
			"name": ".",
			"time": "20.37"
		},
		{
			"duration": "0.12",
			"confidence": "0.910",
			"name": "But",
			"time": "20.58"
		},
		{
			"duration": "0.28",
			"confidence": "0.920",
			"name": "seeing",
			"time": "20.93"
		},
		{
			"duration": "0.20",
			"confidence": "0.690",
			"name": "that",
			"time": "21.24"
		},
		{
			"duration": "0.33",
			"confidence": "0.210",
			"name": "bronze",
			"time": "21.45"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I'm",
			"time": "21.79"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "sorry",
			"time": "21.88"
		},
		{
			"duration": "0.20",
			"confidence": "0.840",
			"name": "can",
			"time": "22.21"
		},
		{
			"duration": "0.11",
			"confidence": "0.580",
			"name": "you",
			"time": "22.46"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hear",
			"time": "22.60"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "me",
			"time": "22.81"
		},
		{
			"duration": "0.03",
			"confidence": "0.860",
			"name": ".",
			"time": "23.11"
		},
		{
			"duration": "0.29",
			"confidence": "0.940",
			"name": "But",
			"time": "23.18"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "23.47"
		},
		{
			"duration": "0.21",
			"confidence": "0.470",
			"name": "Life",
			"time": "27.80"
		},
		{
			"duration": "0.14",
			"confidence": "0.300",
			"name": "is",
			"time": "28.29"
		},
		{
			"duration": "0.36",
			"confidence": "0.330",
			"name": "finished",
			"time": "28.55"
		},
		{
			"duration": "0.33",
			"confidence": "0.770",
			"name": ".",
			"time": "29.08"
		},
		{
			"duration": "0.50",
			"confidence": "0.990",
			"name": "We're",
			"time": "29.99"
		},
		{
			"duration": "0.35",
			"confidence": "0.820",
			"name": "running",
			"time": "31.70"
		},
		{
			"duration": "0.41",
			"confidence": "0.590",
			"name": ".",
			"time": "32.67"
		},
		{
			"duration": "0.25",
			"confidence": "0.900",
			"name": "We",
			"time": "33.54"
		},
		{
			"duration": "0.11",
			"confidence": "0.760",
			"name": "are",
			"time": "34.13"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "still",
			"time": "34.34"
		},
		{
			"duration": "0.37",
			"confidence": "0.890",
			"name": "growing",
			"time": "34.70"
		},
		{
			"duration": "0.12",
			"confidence": "0.750",
			"name": "up",
			"time": "35.07"
		},
		{
			"duration": "0.06",
			"confidence": "0.500",
			"name": ".",
			"time": "35.20"
		},
		{
			"duration": "0.19",
			"confidence": "0.300",
			"name": "And",
			"time": "35.43"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "now",
			"time": "35.69"
		},
		{
			"duration": "0.52",
			"confidence": "0.400",
			"name": "realizing",
			"time": "36.06"
		},
		{
			"duration": "0.27",
			"confidence": "0.950",
			"name": "holy",
			"time": "36.64"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "shit",
			"time": "36.92"
		},
		{
			"duration": "0.11",
			"confidence": "0.710",
			"name": "I",
			"time": "37.53"
		},
		{
			"duration": "0.30",
			"confidence": "0.710",
			"name": "don't",
			"time": "37.67"
		},
		{
			"duration": "0.28",
			"confidence": "0.740",
			"name": "now",
			"time": "38.07"
		},
		{
			"duration": "0.14",
			"confidence": "0.910",
			"name": "and",
			"time": "39.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that's",
			"time": "39.41"
		},
		{
			"duration": "0.26",
			"confidence": "0.710",
			"name": "very",
			"time": "39.62"
		},
		{
			"duration": "0.22",
			"confidence": "0.390",
			"name": "weird",
			"time": "39.88"
		},
		{
			"duration": "0.22",
			"confidence": "0.780",
			"name": "for",
			"time": "40.13"
		},
		{
			"duration": "0.11",
			"confidence": "0.810",
			"name": "me",
			"time": "40.35"
		},
		{
			"duration": "0.55",
			"confidence": "0.440",
			"name": ".",
			"time": "40.47"
		},
		{
			"duration": "0.18",
			"confidence": "0.510",
			"name": "For",
			"time": "45.55"
		},
		{
			"duration": "0.16",
			"confidence": "0.530",
			"name": "sure",
			"time": "45.84"
		},
		{
			"duration": "0.07",
			"confidence": "0.890",
			"name": "I",
			"time": "46.05"
		},
		{
			"duration": "0.25",
			"confidence": "0.770",
			"name": "no",
			"time": "46.16"
		},
		{
			"duration": "0.29",
			"confidence": "0.760",
			"name": "longer",
			"time": "46.41"
		},
		{
			"duration": "0.32",
			"confidence": "0.730",
			"name": "do",
			"time": "48.58"
		},
		{
			"duration": "0.10",
			"confidence": "0.450",
			"name": ".",
			"time": "49.46"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "My",
			"time": "49.57"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "boyfriend",
			"time": "49.69"
		},
		{
			"duration": "0.21",
			"confidence": "0.380",
			"name": "just",
			"time": "51.14"
		},
		{
			"duration": "0.33",
			"confidence": "0.880",
			"name": "weird",
			"time": "52.28"
		},
		{
			"duration": "0.23",
			"confidence": "0.620",
			"name": ".",
			"time": "52.67"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "Really",
			"time": "53.08"
		},
		{
			"duration": "0.26",
			"confidence": "0.860",
			"name": "is",
			"time": "53.44"
		},
		{
			"duration": "0.15",
			"confidence": "0.430",
			"name": "been",
			"time": "53.84"
		},
		{
			"duration": "0.14",
			"confidence": "0.440",
			"name": "over",
			"time": "54.05"
		},
		{
			"duration": "0.46",
			"confidence": "0.610",
			"name": "boy",
			"time": "54.21"
		},
		{
			"duration": "0.22",
			"confidence": "0.800",
			"name": "and",
			"time": "55.13"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "boys",
			"time": "55.42"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "are",
			"time": "55.72"
		},
		{
			"duration": "0.27",
			"confidence": "0.380",
			"name": "messy",
			"time": "55.82"
		},
		{
			"duration": "0.14",
			"confidence": "0.700",
			"name": ".",
			"time": "56.17"
		},
		{
			"duration": "0.16",
			"confidence": "0.740",
			"name": "It's",
			"time": "56.44"
		},
		{
			"duration": "0.23",
			"confidence": "0.600",
			"name": "very",
			"time": "56.90"
		},
		{
			"duration": "0.26",
			"confidence": "0.810",
			"name": "very",
			"time": "57.21"
		},
		{
			"duration": "0.35",
			"confidence": "0.600",
			"name": "rare",
			"time": "57.58"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "but",
			"time": "58.18"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "it's",
			"time": "58.39"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "nice",
			"time": "58.57"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "because",
			"time": "58.93"
		},
		{
			"duration": "0.17",
			"confidence": "0.810",
			"name": "other",
			"time": "59.96"
		},
		{
			"duration": "0.42",
			"confidence": "0.990",
			"name": "days",
			"time": "60.46"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "61.54"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "don't",
			"time": "61.87"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "really",
			"time": "62.05"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "see",
			"time": "62.38"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "myself",
			"time": "62.56"
		},
		{
			"duration": "0.24",
			"confidence": "0.960",
			"name": "doing",
			"time": "64.00"
		},
		{
			"duration": "0.11",
			"confidence": "0.900",
			"name": "as",
			"time": "64.27"
		},
		{
			"duration": "0.18",
			"confidence": "0.890",
			"name": "well",
			"time": "64.39"
		},
		{
			"duration": "0.41",
			"confidence": "0.950",
			"name": "alone",
			"time": "64.59"
		},
		{
			"duration": "0.96",
			"confidence": "0.900",
			"name": ".",
			"time": "66.40"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "68.47"
		},
		{
			"duration": "0.24",
			"confidence": "0.980",
			"name": "can't",
			"time": "68.59"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "remember",
			"time": "68.83"
		},
		{
			"duration": "0.09",
			"confidence": "0.460",
			"name": "if",
			"time": "69.22"
		},
		{
			"duration": "0.19",
			"confidence": "0.470",
			"name": "ever",
			"time": "69.34"
		},
		{
			"duration": "0.45",
			"confidence": "0.850",
			"name": "mention",
			"time": "69.56"
		},
		{
			"duration": "0.49",
			"confidence": "0.930",
			"name": "video",
			"time": "71.03"
		},
		{
			"duration": "0.34",
			"confidence": "0.790",
			"name": "I",
			"time": "72.01"
		},
		{
			"duration": "0.26",
			"confidence": "0.700",
			"name": "told",
			"time": "72.49"
		},
		{
			"duration": "0.10",
			"confidence": "0.950",
			"name": "you",
			"time": "72.78"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "guys",
			"time": "72.88"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "about",
			"time": "73.15"
		},
		{
			"duration": "0.46",
			"confidence": "0.530",
			"name": "Xabier",
			"time": "73.70"
		},
		{
			"duration": "0.14",
			"confidence": "0.700",
			"name": "or",
			"time": "74.20"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "not",
			"time": "74.35"
		},
		{
			"duration": "0.20",
			"confidence": "0.550",
			"name": ".",
			"time": "74.62"
		},
		{
			"duration": "0.31",
			"confidence": "0.870",
			"name": "Right",
			"time": "74.96"
		},
		{
			"duration": "0.64",
			"confidence": "0.730",
			"name": ".",
			"time": "75.27"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I",
			"time": "76.15"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "will",
			"time": "76.36"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "tell",
			"time": "76.54"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "you",
			"time": "76.75"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "about",
			"time": "76.81"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "it",
			"time": "77.08"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "now",
			"time": "77.14"
		},
		{
			"duration": "1.06",
			"confidence": "0.590",
			"name": ".",
			"time": "77.89"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "79.39"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "do",
			"time": "79.48"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "suffer",
			"time": "79.66"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "from",
			"time": "79.96"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "anxiety",
			"time": "80.14"
		},
		{
			"duration": "0.39",
			"confidence": "0.420",
			"name": ".",
			"time": "80.93"
		},
		{
			"duration": "0.15",
			"confidence": "0.790",
			"name": "Right",
			"time": "81.49"
		},
		{
			"duration": "1.10",
			"confidence": "0.750",
			"name": ".",
			"time": "81.79"
		},
		{
			"duration": "0.47",
			"confidence": "0.960",
			"name": "So",
			"time": "83.22"
		},
		{
			"duration": "0.44",
			"confidence": "0.900",
			"name": "that's",
			"time": "83.69"
		},
		{
			"duration": "0.07",
			"confidence": "0.450",
			"name": "a",
			"time": "84.14"
		},
		{
			"duration": "0.31",
			"confidence": "0.940",
			"name": "point",
			"time": "84.22"
		},
		{
			"duration": "0.13",
			"confidence": "0.720",
			"name": "where",
			"time": "84.56"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "85.09"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "can't",
			"time": "85.21"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "focus",
			"time": "85.60"
		},
		{
			"duration": "0.17",
			"confidence": "0.900",
			"name": "for",
			"time": "86.11"
		},
		{
			"duration": "0.27",
			"confidence": "0.890",
			"name": "four",
			"time": "86.29"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "86.56"
		},
		{
			"duration": "0.27",
			"confidence": "0.890",
			"name": "five",
			"time": "86.68"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "days",
			"time": "86.95"
		},
		{
			"duration": "0.57",
			"confidence": "0.540",
			"name": "check",
			"time": "87.90"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "everything",
			"time": "88.48"
		},
		{
			"duration": "0.22",
			"confidence": "0.860",
			"name": "feels",
			"time": "88.99"
		},
		{
			"duration": "0.15",
			"confidence": "0.830",
			"name": "like",
			"time": "89.21"
		},
		{
			"duration": "0.12",
			"confidence": "0.770",
			"name": "a",
			"time": "89.37"
		},
		{
			"duration": "0.43",
			"confidence": "0.460",
			"name": "jillion",
			"time": "89.50"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "89.98"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "me",
			"time": "90.13"
		},
		{
			"duration": "0.27",
			"confidence": "0.800",
			"name": ".",
			"time": "90.31"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "Sometimes",
			"time": "90.64"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "I",
			"time": "91.21"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "can't",
			"time": "91.27"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "remember",
			"time": "91.51"
		},
		{
			"duration": "0.12",
			"confidence": "0.670",
			"name": "what",
			"time": "91.81"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "I'm",
			"time": "91.93"
		},
		{
			"duration": "0.25",
			"confidence": "0.730",
			"name": "saying",
			"time": "92.12"
		},
		{
			"duration": "0.44",
			"confidence": "0.800",
			"name": ".",
			"time": "92.50"
		},
		{
			"duration": "0.46",
			"confidence": "0.990",
			"name": "Continue",
			"time": "93.11"
		},
		{
			"duration": "0.44",
			"confidence": "0.950",
			"name": "talking",
			"time": "93.58"
		},
		{
			"duration": "0.16",
			"confidence": "0.600",
			"name": "and",
			"time": "94.02"
		},
		{
			"duration": "0.41",
			"confidence": "1.000",
			"name": "forget",
			"time": "94.42"
		},
		{
			"duration": "0.23",
			"confidence": "0.970",
			"name": "like",
			"time": "94.84"
		},
		{
			"duration": "0.18",
			"confidence": "0.820",
			"name": "I",
			"time": "95.77"
		},
		{
			"duration": "0.15",
			"confidence": "0.820",
			"name": "am",
			"time": "95.99"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "right",
			"time": "96.16"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "now",
			"time": "96.31"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I'm",
			"time": "96.79"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "not",
			"time": "97.00"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "as",
			"time": "97.15"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bad",
			"time": "97.36"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "as",
			"time": "97.93"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "98.11"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "was",
			"time": "98.20"
		},
		{
			"duration": "0.22",
			"confidence": "0.950",
			"name": "and",
			"time": "99.48"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "99.70"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "also",
			"time": "99.85"
		},
		{
			"duration": "0.39",
			"confidence": "0.990",
			"name": "suffer",
			"time": "100.27"
		},
		{
			"duration": "0.23",
			"confidence": "1.000",
			"name": "from",
			"time": "100.66"
		},
		{
			"duration": "0.28",
			"confidence": "0.590",
			"name": "really",
			"time": "100.93"
		},
		{
			"duration": "0.16",
			"confidence": "0.590",
			"name": "bad",
			"time": "101.21"
		},
		{
			"duration": "0.35",
			"confidence": "0.670",
			"name": "headache",
			"time": "101.57"
		},
		{
			"duration": "1.16",
			"confidence": "0.710",
			"name": ".",
			"time": "102.11"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "I",
			"time": "103.60"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "am",
			"time": "103.90"
		},
		{
			"duration": "0.15",
			"confidence": "0.910",
			"name": "in",
			"time": "104.23"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "a",
			"time": "104.38"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "really",
			"time": "104.98"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "scary",
			"time": "105.49"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "situation",
			"time": "106.00"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "that",
			"time": "106.51"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "I",
			"time": "106.60"
		},
		{
			"duration": "0.20",
			"confidence": "0.980",
			"name": "think",
			"time": "106.72"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "is",
			"time": "106.93"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "scary",
			"time": "106.99"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "107.38"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "me",
			"time": "107.53"
		},
		{
			"duration": "0.09",
			"confidence": "0.540",
			"name": ".",
			"time": "108.10"
		},
		{
			"duration": "0.08",
			"confidence": "0.910",
			"name": "I",
			"time": "108.59"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "feel",
			"time": "108.67"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "like",
			"time": "108.82"
		},
		{
			"duration": "0.11",
			"confidence": "0.620",
			"name": "I've",
			"time": "109.00"
		},
		{
			"duration": "0.28",
			"confidence": "0.630",
			"name": "been",
			"time": "109.11"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "attacked",
			"time": "109.39"
		},
		{
			"duration": "0.40",
			"confidence": "0.590",
			"name": "my",
			"time": "110.67"
		},
		{
			"duration": "0.12",
			"confidence": "0.650",
			"name": "I",
			"time": "112.37"
		},
		{
			"duration": "0.20",
			"confidence": "0.630",
			"name": "will",
			"time": "112.58"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "literally",
			"time": "112.90"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "freeze",
			"time": "113.38"
		},
		{
			"duration": "0.09",
			"confidence": "0.850",
			"name": "up",
			"time": "113.74"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "113.83"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "about",
			"time": "114.01"
		},
		{
			"duration": "0.27",
			"confidence": "0.800",
			"name": "3",
			"time": "115.48"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "seconds",
			"time": "115.75"
		},
		{
			"duration": "0.18",
			"confidence": "0.800",
			"name": "I'll",
			"time": "116.25"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "stop",
			"time": "116.68"
		},
		{
			"duration": "0.47",
			"confidence": "1.000",
			"name": "breathing",
			"time": "116.98"
		},
		{
			"duration": "0.15",
			"confidence": "0.920",
			"name": "all",
			"time": "117.49"
		},
		{
			"duration": "0.20",
			"confidence": "0.910",
			"name": "that",
			"time": "117.64"
		},
		{
			"duration": "0.14",
			"confidence": "0.960",
			"name": "and",
			"time": "117.89"
		},
		{
			"duration": "0.11",
			"confidence": "0.530",
			"name": "then",
			"time": "118.03"
		},
		{
			"duration": "0.11",
			"confidence": "0.840",
			"name": "I'm",
			"time": "118.15"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "not",
			"time": "118.39"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "going",
			"time": "119.14"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "119.32"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "walk",
			"time": "119.38"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "out",
			"time": "119.68"
		},
		{
			"duration": "1.59",
			"confidence": "0.800",
			"name": ".",
			"time": "119.95"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "I",
			"time": "121.93"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "will",
			"time": "122.79"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "123.31"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "start",
			"time": "123.52"
		},
		{
			"duration": "0.90",
			"confidence": "1.000",
			"name": "hyperventilating",
			"time": "123.73"
		},
		{
			"duration": "0.25",
			"confidence": "0.710",
			"name": "things",
			"time": "125.10"
		},
		{
			"duration": "0.32",
			"confidence": "0.970",
			"name": "straight",
			"time": "125.35"
		},
		{
			"duration": "0.05",
			"confidence": "0.620",
			"name": ".",
			"time": "125.67"
		},
		{
			"duration": "0.42",
			"confidence": "0.980",
			"name": "Can't",
			"time": "125.74"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "talk",
			"time": "126.16"
		},
		{
			"duration": "0.42",
			"confidence": "0.990",
			"name": "straight",
			"time": "126.49"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "can't",
			"time": "127.06"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "do",
			"time": "127.33"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "anything",
			"time": "127.54"
		},
		{
			"duration": "0.39",
			"confidence": "0.520",
			"name": "Istria",
			"time": "127.99"
		},
		{
			"duration": "0.10",
			"confidence": "0.590",
			"name": "I",
			"time": "129.79"
		},
		{
			"duration": "0.44",
			"confidence": "0.940",
			"name": "start",
			"time": "130.14"
		},
		{
			"duration": "0.71",
			"confidence": "0.920",
			"name": "crying",
			"time": "130.58"
		},
		{
			"duration": "0.92",
			"confidence": "0.980",
			"name": "hyperventilating",
			"time": "131.87"
		},
		{
			"duration": "0.09",
			"confidence": "0.590",
			"name": "or",
			"time": "133.02"
		},
		{
			"duration": "0.58",
			"confidence": "0.660",
			"name": "goostrey",
			"time": "133.26"
		},
		{
			"duration": "0.42",
			"confidence": "0.250",
			"name": "speaking",
			"time": "133.90"
		},
		{
			"duration": "1.30",
			"confidence": "0.680",
			"name": ".",
			"time": "134.79"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "138.45"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "feel",
			"time": "138.57"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "like",
			"time": "138.69"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "I'm",
			"time": "138.84"
		},
		{
			"duration": "0.03",
			"confidence": "0.980",
			"name": "a",
			"time": "138.93"
		},
		{
			"duration": "0.34",
			"confidence": "0.510",
			"name": "mess",
			"time": "138.96"
		},
		{
			"duration": "0.87",
			"confidence": "0.800",
			"name": ".",
			"time": "139.50"
		},
		{
			"duration": "0.22",
			"confidence": "0.900",
			"name": "This",
			"time": "140.48"
		},
		{
			"duration": "0.08",
			"confidence": "0.900",
			"name": "is",
			"time": "140.72"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "just",
			"time": "140.85"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "part",
			"time": "141.00"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "141.24"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "141.30"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "life",
			"time": "141.45"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "and",
			"time": "141.81"
		},
		{
			"duration": "0.11",
			"confidence": "0.920",
			"name": "I",
			"time": "141.93"
		},
		{
			"duration": "0.13",
			"confidence": "0.900",
			"name": "will",
			"time": "142.04"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "get",
			"time": "142.17"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "through",
			"time": "142.38"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "142.68"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "because",
			"time": "143.10"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "143.34"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "believe",
			"time": "143.46"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "143.91"
		},
		{
			"duration": "0.52",
			"confidence": "1.000",
			"name": "can",
			"time": "144.03"
		},
		{
			"duration": "0.21",
			"confidence": "0.850",
			"name": "and",
			"time": "144.60"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "things",
			"time": "145.35"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "will",
			"time": "145.68"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "get",
			"time": "145.86"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "easier",
			"time": "146.04"
		},
		{
			"duration": "0.06",
			"confidence": "0.760",
			"name": ".",
			"time": "146.61"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "Things",
			"time": "146.67"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "will",
			"time": "146.97"
		},
		{
			"duration": "0.15",
			"confidence": "0.880",
			"name": "get",
			"time": "147.09"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "better",
			"time": "147.24"
		},
		{
			"duration": "0.11",
			"confidence": "0.420",
			"name": ".",
			"time": "147.63"
		},
		{
			"duration": "0.23",
			"confidence": "0.950",
			"name": "Just",
			"time": "147.81"
		},
		{
			"duration": "0.19",
			"confidence": "0.870",
			"name": "right",
			"time": "148.03"
		},
		{
			"duration": "0.29",
			"confidence": "0.870",
			"name": "now",
			"time": "148.23"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "things",
			"time": "148.68"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "are",
			"time": "149.19"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "not",
			"time": "149.31"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "150.03"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "way",
			"time": "150.12"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "I",
			"time": "150.27"
		},
		{
			"duration": "0.32",
			"confidence": "0.990",
			"name": "want",
			"time": "150.45"
		},
		{
			"duration": "0.42",
			"confidence": "0.770",
			"name": "them",
			"time": "150.77"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "151.35"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "be",
			"time": "151.47"
		},
		{
			"duration": "0.20",
			"confidence": "0.880",
			"name": ".",
			"time": "151.77"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "I'm",
			"time": "152.97"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "doing",
			"time": "153.12"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "153.39"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "153.54"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "can",
			"time": "153.66"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "154.29"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "For",
			"time": "155.31"
		},
		{
			"duration": "0.73",
			"confidence": "0.970",
			"name": "myself",
			"time": "155.55"
		},
		{
			"duration": "0.24",
			"confidence": "0.710",
			"name": "for",
			"time": "156.31"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "156.55"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "What",
			"time": "158.37"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "158.61"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "need",
			"time": "158.73"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "to",
			"time": "158.97"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "do",
			"time": "159.12"
		},
		{
			"duration": "0.30",
			"confidence": "0.710",
			"name": "in",
			"time": "159.54"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "159.84"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "Life",
			"time": "163.44"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "will",
			"time": "163.65"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "get",
			"time": "163.74"
		},
		{
			"duration": "0.32",
			"confidence": "1.000",
			"name": "better",
			"time": "163.89"
		},
		{
			"duration": "0.10",
			"confidence": "0.790",
			"name": "and",
			"time": "164.21"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "just",
			"time": "164.31"
		},
		{
			"duration": "0.33",
			"confidence": "0.960",
			"name": "happy",
			"time": "164.74"
		},
		{
			"duration": "0.35",
			"confidence": "0.880",
			"name": "that",
			"time": "166.25"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "167.91"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "parents",
			"time": "168.03"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "are",
			"time": "168.57"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "happy",
			"time": "168.69"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "169.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "me",
			"time": "169.17"
		},
		{
			"duration": "0.76",
			"confidence": "0.940",
			"name": ".",
			"time": "169.32"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "I",
			"time": "170.13"
		},
		{
			"duration": "0.13",
			"confidence": "0.990",
			"name": "mean",
			"time": "170.19"
		},
		{
			"duration": "0.07",
			"confidence": "0.490",
			"name": "my",
			"time": "170.33"
		},
		{
			"duration": "0.17",
			"confidence": "0.490",
			"name": "mother",
			"time": "170.42"
		},
		{
			"duration": "0.18",
			"confidence": "0.490",
			"name": "was",
			"time": "170.69"
		},
		{
			"duration": "0.41",
			"confidence": "0.970",
			"name": "upset",
			"time": "171.08"
		},
		{
			"duration": "0.12",
			"confidence": "0.540",
			"name": "at",
			"time": "171.87"
		},
		{
			"duration": "0.27",
			"confidence": "0.960",
			"name": "what",
			"time": "172.07"
		},
		{
			"duration": "0.23",
			"confidence": "0.890",
			"name": "Mom",
			"time": "172.34"
		},
		{
			"duration": "0.33",
			"confidence": "0.780",
			"name": "wanted",
			"time": "172.57"
		},
		{
			"duration": "0.13",
			"confidence": "0.380",
			"name": "those",
			"time": "177.55"
		},
		{
			"duration": "0.26",
			"confidence": "0.880",
			"name": "things",
			"time": "177.84"
		},
		{
			"duration": "1.43",
			"confidence": "0.660",
			"name": ".",
			"time": "178.15"
		},
		{
			"duration": "0.21",
			"confidence": "0.960",
			"name": "I",
			"time": "180.11"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "personally",
			"time": "180.35"
		},
		{
			"duration": "0.20",
			"confidence": "0.640",
			"name": "I",
			"time": "181.04"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "181.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "181.46"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "say",
			"time": "181.61"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I'm",
			"time": "181.85"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "fine",
			"time": "182.00"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "but",
			"time": "183.11"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "I",
			"time": "183.26"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "would",
			"time": "183.68"
		},
		{
			"duration": "0.39",
			"confidence": "0.990",
			"name": "also",
			"time": "183.92"
		},
		{
			"duration": "0.39",
			"confidence": "0.910",
			"name": "say",
			"time": "184.33"
		},
		{
			"duration": "0.10",
			"confidence": "0.510",
			"name": "I'm",
			"time": "184.76"
		},
		{
			"duration": "0.00",
			"confidence": "1.000",
			"name": ".",
			"time": "184.86"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/anxiety.json
// module id = 24
// module chunks = 0